import React, { Component } from 'react';
import { isEmpty, getDateFromDayByWeek, getMonthName, getWeekName, getDayName, getLocale } from '../../../Common/Common';
import Select from '../../../Part_Sample/Select';
import edit_icon from '../../../../Images/Daikin_Images/image/Edit.png';
import plus from '../../../../Images/Daikin_Images/image/Add.png';

export default class Special_Calendar extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	handleChangeCalendarList = (key) => {
		this.props.handleChangeSpecialCalendar(key);
	}

	handleCalendarList = (key) => {
		// Redirect to add_edit_calendar
		this.props.handleCalendarList(key);
	}

	render() {
		const calendar_options = [];

		calendar_options.push(<option value={''} key={'calendar_id'}>{this.props.receiver.getString('none')}</option>);

		for (let calendar_id in this.props.calendar_list) {
			if (calendar_id == this.props.selected_calendar_id) {
				calendar_options.push(<option selected={true} value={calendar_id} key={'calendar_id-' + calendar_id}>{this.props.calendar_list[calendar_id].name}</option>);
			} else {
				calendar_options.push(<option value={calendar_id} key={'calendar_id-' + calendar_id}>{this.props.calendar_list[calendar_id].name}</option>);
			}
		}

		let calendar = {};

		if (this.props.selected_calendar_id != '') {
			calendar = this.props.calendar_list[this.props.selected_calendar_id];
		}
		if (isEmpty(calendar.date)) calendar.date = {};
		if (isEmpty(calendar.dow)) calendar.dow = {};

		let display_dates = [];
		let display_dow = [];
		let today = new Date();
		let new_date = new Date(today);
		let locale = getLocale(this.props.receiver.lang);
		for (let month in calendar.date) {
			for (let date of calendar.date[month]) {
				new_date = new Date(today);
				new_date.setMonth(month - 1);
				new_date.setDate(date);

				display_dates.push(new_date)
			}
		}

		for (let month in calendar.dow) {
			for (let nth_week in calendar.dow[month]) {
				let days = calendar.dow[month][nth_week];
				for (let day of days) {
					let dow = {}
					dow.month = getMonthName(month - 1);
					dow.week = getWeekName(nth_week);
					dow.day = getDayName(day);
					display_dow.push(dow)
				}
			}
		}

		//display_dates.sort();
		display_dow.sort();
		let dropdown_left_margin = 80;

		return (
			<div>
				<div style={{ marginTop: 20 }}>
					<div style={{ display: 'inline-block', textAlign: 'left', width: this.props.width - 65, height: 25, }}>
						<span className='subtitle' >{this.props.receiver.getString('sp_cal')}</span>
					</div>
					<div id='calendar' style={{ display: 'inline-block', width: 25, height: 25, verticalAlign: 'bottom' }} onClick={() => { this.handleCalendarList('') }}>
						<img src={plus} style={{ cursor: 'pointer', width: 25, paddingTop: 5 }} />
					</div>
				</div>
				<div style={{ textAlign: 'left', marginLeft: 20, marginTop: 20, marginBottom: 20 }} >
					<div style={{ width: this.props.width - 70, display: 'inline-block' }}>
						<Select
							options={calendar_options}
							value={this.props.selected_calendar_id}
							onSelect={this.handleChangeCalendarList}
						/>
					</div>
					<div style={{ display: this.props.selected_calendar_id != '' ? 'inline-block' : 'none', width: 30, height: 30, verticalAlign: 'bottom' }}>
						<img src={edit_icon} style={{ cursor: 'pointer', width: 30, height: 30 }} onClick={() => { this.handleCalendarList(this.props.selected_calendar_id) }} />
					</div>
				</div>
				{/* Tommy - 24/06/2021 - Change height from this.props.height-330 to auto and add paddingTop and paddingBottom */}
				<div style={{
					display: this.props.selected_calendar_id != '' ? 'block' : 'none', width: this.props.width - 40,
					paddingTop: 10, paddingBottom: 10, height: 'auto', marginLeft: 'auto', marginRight: 'auto', marginBottom: 10, textAlign: 'center', boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
				}}>
					<div style={{ paddingTop: 10, textAlign: 'left', marginLeft: 10 }}>
						<span>{this.props.receiver.getString('cal_detail')}</span>
					</div>
					<div style={{ display: display_dates.length > 0 ? 'block' : 'none', textAlign: 'left', marginLeft: 20, marginTop: 20 }}>
						<div style={{ width: '10px', height: '10px', backgroundColor: '#f1c40f', display: 'inline-block', marginRight: '10px' }} />
						<span style={{ display: 'inline-block' }}>{this.props.receiver.getString('date_sp')}</span>
					</div>
					{display_dates.map((date) => {
						let df_options = { month: 'long', day: 'numeric' };
						return (
							<div style={{ textAlign: 'left', marginTop: 10, marginLeft: 40 }}>
								<span>{'* ' + date.toLocaleString(locale, df_options)}</span>
							</div>
						)
					})}
					<div style={{ display: display_dow.length > 0 ? 'block' : 'none', textAlign: 'left', marginLeft: 20, marginTop: 20 }}>
						<div style={{ width: '10px', height: '10px', backgroundColor: '#2ecc71', display: 'inline-block', marginRight: '10px' }} />
						<span style={{ display: 'inline-block' }}>{this.props.receiver.getString('dow_sp')}</span>
					</div>

					{display_dow.map((date) => {
						let day = date.day;
						let week = date.week;
						let month = date.month;
						return (
							<div style={{ textAlign: 'left', marginTop: 20, marginLeft: 40 }}>
								<span>{'* ' + month + ' ' + week + ' ' + day}</span>
							</div>
						)
					})}
				</div>
			</div>
		)
	}
}
